export default "__VITE_ASSET__UnTft82n__"